// src/switch/src/switch.tsx
import { cva } from "class-variance-authority";
import * as RadixSwitch from "@radix-ui/react-switch";
import { useId } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var labelCva = cva("order-2", {
  variants: {
    disabled: {
      false: "cursor-pointer",
      true: "cursor-default"
    }
  }
});
var rootCva = cva(
  "relative order-1 h-[1.125rem] w-8 rounded-full border outline-2 outline-offset-1 outline-interactive-focus focus:outline",
  {
    compoundVariants: [
      // Only show 'on' background when not disabled
      {
        checked: true,
        className: "border-interactive-secondary bg-interactive-secondary",
        disabled: false
      },
      {
        checked: false,
        className: "border-surface-border bg-surface-border",
        disabled: false
      }
    ],
    variants: {
      checked: {
        false: ""
      },
      disabled: {
        true: "border-interactive-disabled bg-interactive-disabled"
      }
    }
  }
);
var thumbCva = cva(
  "block size-4 rounded-full bg-surface-light transition-all will-change-transform",
  {
    variants: {
      checked: {
        true: "translate-x-3.5"
      }
    }
  }
);
var Switch = ({
  "aria-controls": ariaControls,
  checked = false,
  disabled = false,
  label,
  onCheckedChange
}) => {
  const labelId = useId();
  const switchId = useId();
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ jsx("label", { className: labelCva({ disabled }), htmlFor: switchId, id: labelId, children: label }),
    /* @__PURE__ */ jsx(
      RadixSwitch.Root,
      {
        "aria-controls": ariaControls,
        "aria-disabled": disabled,
        "aria-labelledby": labelId,
        checked,
        className: rootCva({ checked, disabled }),
        disabled,
        id: switchId,
        onCheckedChange,
        children: /* @__PURE__ */ jsx(RadixSwitch.Thumb, { className: thumbCva({ checked }) })
      }
    )
  ] });
};

export {
  Switch
};
